import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'prgov-tool-bar',
  templateUrl: './tool-bar.component.html',
  styleUrls: ['./tool-bar.component.scss']
})
export class ToolBarComponent implements OnInit, OnDestroy {
  profileName: string = 'Usuario';
  profileType: string = '';
  private profileChangedHandler: EventListener;

  menuOptions = [];
  @Output() openOptionMenu = new EventEmitter();

  constructor(
    private router: Router,
    public authService: AuthService
  ) {
    // Definir el handler como propiedad de la clase para poder eliminarlo después
    this.profileChangedHandler = () => {
      this.loadProfileInfo();
    };
  }

  ngOnInit() {
    this.loadProfileInfo();

    // Escuchar el evento de cambio de perfil
    window.addEventListener('profileChanged', this.profileChangedHandler);

    this.menuOptions = this.authService.getMenuItems();
  }

  ngOnDestroy() {
    // Eliminar el event listener cuando se destruye el componente
    window.removeEventListener('profileChanged', this.profileChangedHandler);
  }

  // Carga la información del perfil desde localStorage
  loadProfileInfo() {
    try {
      let profileData = localStorage.getItem('selectedProfile');

      if (profileData) {
        const profile = JSON.parse(profileData);
        this.profileName = profile.Name || 'Usuario';
        // Si hay información sobre el tipo de perfil, actualizarla
        if (profile.ProfileTypeName) {
          this.profileType = profile.ProfileTypeName;
        }
      } else {
        const data = JSON.parse(localStorage.getItem('userProfile'));
        if (data.profiles.length > 0) {
          this.profileName = data.profiles[0].Name || 'Usuario';
          // Si hay información sobre el tipo de perfil, actualizarla
          if (data.profiles[0].ProfileTypeName) {
            this.profileType = data.profiles[0].ProfileTypeName;
          }
        } else {
          this.profileName = 'Usuario';
          this.profileType = '';
        }
      }
    } catch (error) {
      console.error('Error al cargar el perfil:', error);
    }
  }

  openOption(value: any) {
    this.router.navigateByUrl(value.Route);
  }
}
